// VEVOタブを表示する対象施設のリスト
// family APIのレスポンスに施設ID(nurseryId)が含まれないため、施設名(nurseryName)で判定する
// 施設名が変更されるとこの判定が壊れるため、リネーム時はこのリストも更新すること
export const VEVO_ENABLED_NURSERY_NAMES: string[] = [
  'AIAI NURSERY 豊四季',
  'AIAI NURSERY 鴫野駅前',
  'AIAI NURSERY 第二東池袋',
  'おが〜る園',
  '森田請求確認施設',
  '深田さんテスト施設',
  'stg_VEVOレポート検証',
  'stgvevoレポート',
  'マニュアル保育園',
  'WSマニュアル園',
  'リリース時確認施設',
  '20260716_VEVOレポート検証',
  'DEV環境AIレポートテスト園',
  '内製化会議デモ',
  'Lambda_devテスト施設',
  'Lambda_stgテスト施設'
];

export function isVevoEnabledNursery(
  nurseryName: string | null | undefined,
): boolean {
  if (!nurseryName) {
    return false;
  }
  return VEVO_ENABLED_NURSERY_NAMES.includes(nurseryName);
}
